import React from "react"
import PropTypes from "prop-types"
import 'app/static/stylus/reusable_components/attachments.styl'
import swal from 'sweetalert'
/*
 * fileSizeToString converts a numerical file size in bytes to a useful human
 * readable string.
 */
const fileSizeToString = (fSize) => {
    if (fSize > 26214400) {
        swal('Files must be less than 20mb')
        return ''
    }
    const fSExt = ['Bytes', 'KB', 'MB']
    let i = 0
    while (fSize > 900) {
        // eslint-disable-next-line no-param-reassign
        fSize /= 1024
        i += 1
    }
    return `${Math.round(fSize * 100) / 100} ${fSExt[i]}`
}
/*
 * An AttachmentCard represents an uploaded attachment.
 */
const propTypes = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
    displayedAttachment: PropTypes.number,
    hideDelete: PropTypes.bool.isRequired,
    canPreview: PropTypes.bool,
    deleteAttachment: PropTypes.func,
    onAttachmentClick: PropTypes.func,
}
const defaultProps = {
    hideDelete: false
}
const AttachmentCard = (props) => {
    const downloadFile = () => $.fileDownload(`/outbox/download/${props.id}/`)

    const deleteFile = event => props.deleteAttachment(event, props.id)

    const onPreviewClick = () => props.displayedAttachment === props.id
        ? props.onAttachmentClick(null)
        : props.onAttachmentClick(props.id)

    return (
        <div className="attachment-card">
            { !props.hideDelete && (
                <div className="outer-icon-container" onClick={deleteFile}>
                    <div className="delete-icon-container">
                        <i className="delete-icon fa fa-minus-circle fa-sm" />
                    </div>
                </div>
            )}
            { props.canPreview && (
                <div className="outer-icon-container" onClick={onPreviewClick}>
                    <div className="delete-icon-container">
                        <i className="delete-icon fa fa-eye fa-sm" />
                    </div>
                </div>
            )}
            <div onClick={downloadFile}>
                <div className="col-sm-3 file-img-container">
                    <i className="fa fa-file f-img" />
                </div>
                <div className="col-sm-8 file-info-container">
                    <div className="fname">
                        { props.name }
                    </div>
                    <div className="fsize">
                        { fileSizeToString(props.size) }
                    </div>
                </div>
            </div>
        </div>
    )
}
AttachmentCard.propTypes = propTypes
AttachmentCard.defaultProps = defaultProps

export default AttachmentCard
